import { api } from "./client";

const asList = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.results)) return data.results;
  return [];
};

export const getRoutes = () =>
  api.get("/routes/", { params: { page_size: 100 } });

export const listRoutes = async () => {
  const response = await getRoutes();
  return asList(response.data);
};

export const getRoute = (id) => api.get(`/routes/${id}/`);

export const createRoute = (payload) => api.post("/routes/", payload);

export const patchRoute = (id, payload) => api.patch(`/routes/${id}/`, payload);
